import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

export default function AboutPage() {
  const { t } = useTranslation('about');

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CookieBanner />

      <section className="pt-32 pb-40 bg-[#F2F4F5]">
        <div className="max-w-[1280px] mx-auto px-10">
          <div className="mb-16">
            <span className="inline-block bg-[#1BCDFF]/10 text-[#0A2D50] text-xs uppercase tracking-wider px-4 py-2 rounded-full mb-4">
              {t('label')}
            </span>
            <h1
              className="text-6xl font-bold text-[#0A2D50] max-w-[680px]"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              {t('title')}
            </h1>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-20">
            <div className="md:col-span-3 space-y-16">
              <div>
                <h2 className="text-xl font-semibold text-[#0A2D50] mb-4">
                  {t('purpose.title')}
                </h2>
                <p className="text-base text-gray-600 leading-relaxed max-w-[540px]">
                  {t('purpose.content')}
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-[#0A2D50] mb-4">
                  {t('principles.title')}
                </h2>
                <p className="text-base text-gray-600 leading-relaxed max-w-[540px]">
                  {t('principles.content')}
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-[#0A2D50] mb-4">
                  {t('governance.title')}
                </h2>
                <p className="text-base text-gray-600 leading-relaxed max-w-[540px]">
                  {t('governance.content')}
                </p>
              </div>
            </div>

            <div className="md:col-span-2">
              <div className="sticky top-32 bg-white p-8 rounded-2xl shadow-sm">
                <h3 className="text-lg font-semibold text-[#0A2D50] mb-6">
                  {t('separation.title')}
                </h3>

                <div className="space-y-6">
                  <div className="bg-[#F2F4F5] p-6 rounded-xl">
                    <div className="text-sm font-semibold text-[#0A2D50] mb-3">
                      {t('separation.holdco.label')}
                    </div>
                    <ul className="space-y-2">
                      {t('separation.holdco.items', { returnObjects: true }).map((item: string, index: number) => (
                        <li key={index} className="text-sm text-gray-600 flex items-start">
                          <span className="text-[#1BCDFF] mr-2">•</span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="flex justify-center">
                    <i className="ri-arrow-down-line text-2xl text-gray-400"></i>
                  </div>

                  <div className="bg-[#F2F4F5] p-6 rounded-xl">
                    <div className="text-sm font-semibold text-[#0A2D50] mb-3">
                      {t('separation.participations.label')}
                    </div>
                    <ul className="space-y-2">
                      {t('separation.participations.items', { returnObjects: true }).map((item: string, index: number) => (
                        <li key={index} className="text-sm text-gray-600 flex items-start">
                          <span className="text-[#1BCDFF] mr-2">•</span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}